import { makeStyles } from 'tss-react/mui';
import { pickIf } from '../../../utils/pickIf';

export const useStyles = makeStyles()(
  (theme, { detailsMode, isTabletMode, isMobileMode } = {}) => ({
    container: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      flexDirection: pickIf(detailsMode, 'row', 'column'),
      gap: pickIf(detailsMode, 10, 4),
      padding: 0,
      [theme.breakpoints.down('md')]: {
        flexDirection: 'row',
        gap: 10,
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          flexDirection: 'row',
          gap: 10,
        }),
      },
    },
    qtyButtonLabel: {
      [theme.breakpoints.down('lg')]: {
        position: pickIf(
          !isMobileMode && isTabletMode && !detailsMode,
          'absolute',
          'static',
        ),
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          position: pickIf(
            !isMobileMode && isTabletMode && !detailsMode,
            'absolute',
            'static',
          ),
        }),
      },
    },
    qtyButtonLabelContainer: {
      position: 'relative',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    countButton: {
      width: 130,
      height: 36,
      [theme.breakpoints.down('lg')]: {
        width: pickIf(detailsMode, 200, 130),
        height: pickIf(detailsMode, 44, 34),
      },
      [theme.breakpoints.down('md')]: {
        width: pickIf(detailsMode, 140, 95),
        height: pickIf(detailsMode, 44, 24),
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          width: pickIf(detailsMode, 200, 130),
          height: pickIf(detailsMode, 44, 34),
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          width: pickIf(detailsMode, 140, 95),
          height: pickIf(detailsMode, 44, 24),
        }),
      },
    },
  }),
);
